export default {
      id: "unit_dashboard__battery-usage",
      viewBox: "0 0 48 29",
      url: __webpack_public_path__ + "img/icons.svg#unit_dashboard__battery",
      toString: function () {
        return this.url;
      }
    }